import * as React from "react"
import { ShopProvider } from "./src/wrappers/Shop"
import 'swiper/css'

export const wrapRootElement = ({ element }) => (
  <ShopProvider>{element}</ShopProvider>
)
// export const wrapRootElement = ({ element }) => element